import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon/Icon'
import copyToClipboard from '../../utils/copyToClipboard'
import './CopyButton.sass'

function CopyButton({
  value,
  size = 14,
  className = '',
  title,
  ariaLabel = 'Скопіювати',
  disabled = false,
  stopPropagation = true,
  resetDelayMs = 2000,
  showLabel = false,
  onCopied,
  onCopyError,
}) {
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef(null)

  useEffect(
    () => () => {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current)
      }
    },
    []
  )

  const handleClick = async (event) => {
    if (stopPropagation) {
      event.stopPropagation()
    }

    if (!value || disabled) {
      return
    }

    try {
      await copyToClipboard(value)
      setCopied(true)
      onCopied?.()

      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current)
      }

      timeoutRef.current = window.setTimeout(() => {
        setCopied(false)
      }, resetDelayMs)
    } catch (error) {
      console.error('[CopyButton] Copy failed:', error)
      onCopyError?.(error)
    }
  }

  const buttonTitle = title || (copied ? 'Скопійовано' : 'Скопіювати')

  const classes = [
    'CopyButton',
    copied && 'CopyButton_copied',
    showLabel && 'CopyButton_withLabel',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type="button"
      className={classes}
      title={buttonTitle}
      aria-label={ariaLabel}
      disabled={disabled || !value}
      onClick={handleClick}
    >
      <Icon name={copied ? 'check' : 'copy'} weight="regular" size={size} />
      {showLabel ? (
        <span className="CopyButton-Label">{copied ? 'Скопійовано' : 'Скопіювати'}</span>
      ) : null}
    </button>
  )
}

CopyButton.propTypes = {
  value: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  stopPropagation: PropTypes.bool,
  resetDelayMs: PropTypes.number,
  showLabel: PropTypes.bool,
  onCopied: PropTypes.func,
  onCopyError: PropTypes.func,
}

export default CopyButton
